import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Environment } from '../../../environment';
import { HatcheriesResponse, Hatchery } from '../models/cycle.model';

@Injectable({
  providedIn: 'root',
})
export class HatcheryService {
  private baseUrl = `${this.env.API_BASE_URL}/service/hatchery/secure`;

  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: Environment,
  ) {}

  public getHatcheries(): Observable<Hatchery[] | HttpErrorResponse> {
    return this.http
      .get<HatcheriesResponse>(`${this.baseUrl}/hatchery?animalType=Rearing&withCountry=false`)
      .pipe(
        map((response) => response.hatcheries),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of(<Hatchery[]>[]);
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }
}
